import Vue from './app.js';
import {router} from './app.js';

export default {
    validate(context, idclient, month, year) {
      Vue.http.post(
        'api/timesheet/validate',
        {
            idclient : idclient,
            month : month,
            year : year,
        }
      ).then(response => {
            context.response = response.data;
            console.log(response.data);
            context.getTimesheetDataValidate();
      })
    }
}


// WEBPACK FOOTER //
// ./assets/js/timesheets.js